// extracted by mini-css-extract-plugin
export default {"backgroundImage":"BackgroundImage_solo_backgroundImage__1lSMy"};